import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanLoad,
  ActivatedRouteSnapshot,
  Router,
  Route,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../services/authentication';

@Injectable({ providedIn: 'root' })
export class OwnershipContractorAuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const user: any = this.authenticationService.userValue;
    if (
      user &&
      user.organizationId.jpaContractor.ownershipType.optionId !==
        'foreign_owned'
    ) {
      return true;
    } else {
      console.log('failed');
      this.router.navigate(['/home-page']);
      alert("You're not authorised to view this page");
      return false;
    }
  }
}
